import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
import { AdminClient, client } from './client.js';

// Initialize the admin client
client.value = new AdminClient();

createApp(App).mount('#app');
